import { call, put, take, actionChannel, takeEvery } from "redux-saga/effects";
import { buffers } from "redux-saga";

import { POST, GET } from "../types/request.types";
import { requestHandler } from "./fetcher.saga";
import {
  CHECK_SERVICE_OPEN_RESTAURANT_SUCCESS,
  CREATE_TOKEN_STRIPE,
  PRE_CHECK_SERVICE_OPEN_RESTAURANT,
  PRE_CREATE_TOKEN_STRIPE,
  REQUEST_CHECK_SERVICE_OPEN_RESTAURANT,
  REQUEST_CHECK_SERVICE_OPEN_RESTAURANT_FINISHED,
  REQUEST_CREATE_TOKEN_STRIPE,
  REQUEST_CREATE_TOKEN_STRIPE_FINISHED,
  REQUEST_UPDATE_FROZEN_SLOTS,
  REQUEST_UPDATE_FROZEN_SLOTS_SUCCESS,
} from "../types/restaurant.types";

export function* preCreateTokenStripeRestaurant() {
  while (true) {
    const action = yield take(PRE_CREATE_TOKEN_STRIPE);
    const { authCode, idRestaurant } = action;
    yield put({
      type: REQUEST_CREATE_TOKEN_STRIPE,
      body: {
        authCode,
        idRestaurant,
      },
    });

    const { response } = yield take(REQUEST_CREATE_TOKEN_STRIPE_FINISHED);
    yield put({
      type: CREATE_TOKEN_STRIPE,
      response: response.data.success,
      message: response.data.message,
      stripeUserId: response.data.stripeUserId,
    });
  }
}

export function* watchCreateTokenStripeRestaurant() {
  const requestChan = yield actionChannel(
    REQUEST_CREATE_TOKEN_STRIPE,
    buffers.expanding()
  );
  const storageToken =
    (typeof window !== "undefined" &&
      window.localStorage.getItem("refreshToken")) ||
    "";
  while (true) {
    const action = yield take(requestChan);
    const result = yield call(
      requestHandler,
      POST,
      `restaurant/admin/token/${action.body.idRestaurant}/${action.body.authCode}`,
      {},
      storageToken
    );
    yield put({
      type: REQUEST_CREATE_TOKEN_STRIPE_FINISHED,
      response: result,
    });
  }
}

export function* preCheckServiceOpenRestaurant() {
  while (true) {
    const action = yield take(PRE_CHECK_SERVICE_OPEN_RESTAURANT);
    const { idRestaurant } = action;
    const nav_lang = window.navigator.language;
    yield put({
      type: REQUEST_CHECK_SERVICE_OPEN_RESTAURANT,
      body: {
        idRestaurant,
        nav_lang,
      },
    });

    const { response } = yield take(
      REQUEST_CHECK_SERVICE_OPEN_RESTAURANT_FINISHED
    );
    yield put({
      type: CHECK_SERVICE_OPEN_RESTAURANT_SUCCESS,
      response: response.data,
    });
  }
}

export function* watchCheckServiceOpenRestaurant() {
  const requestChan = yield actionChannel(
    REQUEST_CHECK_SERVICE_OPEN_RESTAURANT,
    buffers.expanding()
  );

  while (true) {
    const action = yield take(requestChan);
    const result = yield call(
      requestHandler,
      GET,
      `restaurant/service-open/${action.body.idRestaurant}/${action.body.nav_lang}`
    );

    yield put({
      type: REQUEST_CHECK_SERVICE_OPEN_RESTAURANT_FINISHED,
      response: result,
    });
  }
}

export function* watchUpdateFrozenSlots() {
  yield takeEvery(REQUEST_UPDATE_FROZEN_SLOTS, updateSlots);
}

export function* updateSlots(action) {
  const { restaurantId } = action;

  const frozenSlots = yield call(
    requestHandler,
    GET,
    `/restaurant/frozen-slots/${restaurantId}`
  );

  yield put({
    type: REQUEST_UPDATE_FROZEN_SLOTS_SUCCESS,
    response: frozenSlots,
  });
}